import * as React from "react";
import { connect } from "react-redux";

import Config from "../config";
import { companyActions } from "../modules/companies";
import * as notifications from "../modules/notifications/actions";
import { sessionActions } from "../modules/session";
import { setPageTitle } from "../modules/title";
import { trackerActions } from "../modules/tracker";
import { AuthEvents } from "../modules/tracker/event-names";
import { userActions } from "../modules/user";

import CircularProgress from "material-ui-old/CircularProgress";
import MyAccountNav from "../components/MyAccount/MyAccountNav";
import MyProfileForm from "../components/MyAccount/MyProfileForm";

import * as styles from "../styles/components/MyAccount.css";

// ! this component is no longer used, as it simply redirects to the beta profile page
class MyAccountContainer extends React.PureComponent {
    constructor(props) {
        window.location.replace(`${Config.general().betaHost}/profile`);
        super(props);
    }

    contentHasLoaded(props) {
        return !!props.company;
    }

    componentWillMount() {
        if (!this.contentHasLoaded(this.props)) {
            this.props.fetchCompany(this.props.companyId);
        }
        this.props.setPageTitle("My Account");
    }

    componentWillReceiveProps(newProps) {
        if (!this.contentHasLoaded(newProps)) {
            newProps.fetchCompany(newProps.companyId);
        }
        newProps.setPageTitle("My Account");
    }

    render() {
        return null; // prevent old profile page from rendering while redirect to beta profile page occurrs
        if (!this.contentHasLoaded(this.props)) {
            return (
                <div style={{ width: "100%", height: "100%", display: "flex" }}>
                    <div style={{ margin: "auto" }}>
                        <CircularProgress />
                    </div>
                </div>
            );
        }

        return (
            <div>
                <nav className={styles.leftNav}>
                    <MyAccountNav
                        logOut={() => {
                            this.props.trackEvent(AuthEvents.DID_LOGOUT);
                            this.props.logOut();
                        }}
                    />
                </nav>
                <main className={styles.contentWithLeftNav}>
                    <MyProfileForm
                        user={this.props.user}
                        team={this.props.team}
                        company={this.props.company}
                        updateProfile={this.props.updateUser}
                        notifySuccess={this.props.notifySuccess}
                    />
                </main>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const user = state.entities.users[state.session.userId];
    const team = state.entities.teams[state.session.teamId];

    const companyId = team.companyId;
    const company = state.entities.companies[companyId];

    return {
        user,
        team,
        companyId,
        company
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchCompany: companyId =>
            dispatch(companyActions.fetchCompany(companyId)),
        logOut: () => dispatch(sessionActions.resetAuthToken()),
        trackEvent: (eventName, eventProperties) =>
            dispatch(trackerActions.trackEvent(eventName, eventProperties)),
        setPageTitle: name => dispatch(setPageTitle(name)),
        updateUser: (userId, properties) =>
            dispatch(userActions.updateUser(userId, properties)),
        notifySuccess: (message, icon, button) =>
            dispatch(notifications.notifySuccess(message, icon, button))
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MyAccountContainer);



// WEBPACK FOOTER //
// ./src/containers/MyAccountContainer.js